module.exports = __webpack_public_path__ + "static/media/new-logo.3db12cc1.png";